import React from "react";
import { DfpComponent } from "../../../ads/dfp-component";
import "./ad-wrapper.m.css";

export default function AdWrapper({
  adStyleName,
  id,
  path,
  size,
  viewPortSizeMapping,
  isLhsAd = false,
  isStickyAd = false,
  count = 0,
}) {
  return isLhsAd ? (
    <div styleName="lhs-ad-wrapper">
      <div styleName="lhs-ad-slot">
        <DfpComponent
          adStyleName={adStyleName}
          id={id}
          path={path}
          size={size}
          viewPortSizeMapping={viewPortSizeMapping}
          count={count}
        />
      </div>
    </div>
  ) : (
    <div styleName={isStickyAd ? "sticky-ad-slot" : "wrapper"}>
      <div styleName="ad-slot">
        <DfpComponent
          adStyleName={adStyleName}
          id={id}
          path={path}
          size={size}
          viewPortSizeMapping={viewPortSizeMapping}
          isStickyAd={isStickyAd}
          count={count}
        />
      </div>
    </div>
  );
}
